/* Decorations only: commerce and navigation never depend on this script. */
(() => {
  const root = document.querySelector('#main-content.bc-christmas');
  if (!root) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let paused = false;
  try { paused = sessionStorage.getItem('byards-christmas-paused') === 'true'; } catch (_) {}
  function decoratePaper() {
    if (!root.classList.contains('bc-christmas--paper')) return;
    ['rich_text_TDC4id', 'promo_strip_CmyDmn', 'image_banner_cjzTzY', 'rich_text_NWpMmx', 'multi_column_J3kcxq', 'faq_NT4mCb'].forEach(id => {
      const section = root.querySelector(`[id$="__${id}"]`);
      if (!section || section.querySelector('.bc-section-lights')) return;
      const lights = document.createElement('div');
      lights.className = 'bc-section-lights';
      lights.setAttribute('aria-hidden', 'true');
      for (let i = 0; i < 6; i++) lights.appendChild(document.createElement('span'));
      section.appendChild(lights);
    });
  }
  function sync() {
    const stopped = paused || reduced.matches;
    root.classList.toggle('bc-motion-running', !stopped);
    root.querySelectorAll('[data-bc-motion]').forEach(button => {
      button.hidden = reduced.matches;
      button.setAttribute('aria-pressed', String(paused));
      button.textContent = paused ? 'Resume festive lights' : 'Pause festive lights';
    });
  }
  root.addEventListener('click', event => {
    if (!event.target.closest('[data-bc-motion]')) return;
    paused = !paused;
    try { sessionStorage.setItem('byards-christmas-paused', String(paused)); } catch (_) {}
    sync();
  });
  if (reduced.addEventListener) reduced.addEventListener('change', sync);
  document.addEventListener('shopify:section:load', () => { decoratePaper(); sync(); });
  decoratePaper();
  sync();
})();
